import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

// Convenience helpers
export const getJSON = (url, config) => api.get(url, config).then((r) => r.data);
export const postJSON = (url, data, config) => api.post(url, data, config).then((r) => r.data);
export const patchJSON = (url, data, config) => api.patch(url, data, config).then((r) => r.data);
export const del = (url, config) => api.delete(url, config).then((r) => r.data);
